/// <amd-module name="Build/Common/Library/Components/CopyToClipboardButton" />
import * as React from "react";

import * as Resources from "Build/Common/Library/Resources";

import { Button } from "VSSUI/Button";

export interface ICopyToClipboardButtonState {
    isCalloutVisible: boolean;
}

export interface ICopyToClipboardButtonProps {
    className?: string;
    onClickStopPropagation?: boolean;
    textToCopy: () => string;
}

export class CopyToClipboardButton extends React.Component<ICopyToClipboardButtonProps, ICopyToClipboardButtonState> {
    private _buttonWrapper = React.createRef<HTMLDivElement>();

    constructor(props: ICopyToClipboardButtonProps) {
        super(props);

        this.state = { isCalloutVisible: false };
    }

    public render() {
        return (
            <div ref={this._buttonWrapper} className={this.props.className}>
                {this._getRenderContents()}
            </div>
        )
    }

    private _getRenderContents() {
        if (!this.state.isCalloutVisible) {
            return this._getButton(Resources.CopyToClipboardText);
        }

        return this._getButton(Resources.CopiedToClipboardText);
    }

    private _getButton(tooltipText: string): JSX.Element {
        return (
            <Button
                subtle={true}
                ariaLabel={Resources.ARIALabelCopyToClipboard}
                iconProps={{ iconName: "Copy" }}
                onClick={this._onShowCopyClicked}
                onBlur={this._onCalloutDismiss}
                tooltipProps={{
                    showOnFocus: true,
                    text: tooltipText
                }} />
        );
    }

    private _onShowCopyClicked = (event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>): void => {
        this.setState({
            isCalloutVisible: true
        });

        const textToCopy = this.props.textToCopy();

        // IE11 Compatible
        if ((window as any).clipboardData) {
            (window as any).clipboardData.setData('text', textToCopy);
            this.props.onClickStopPropagation && event.stopPropagation();
            return;
        }

        const listener = (e: ClipboardEvent) => {
            if (e.clipboardData) {
                e.clipboardData.setData('text', textToCopy);
                e.preventDefault();
            }
        };
        document.addEventListener('copy', listener);
        document.execCommand("copy");
        document.removeEventListener('copy', listener);

        this.props.onClickStopPropagation && event.stopPropagation();
    };

    private _onCalloutDismiss = (): void => {
        this.setState({
            isCalloutVisible: false
        });
    };
}
